import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const next = params.get('next') || '/';

  useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      if (!email || !password) {
        setError('Informe e-mail e senha.');
        return;
      }
      await login(email, password);
      navigate(next, { replace: true });
    } catch (err) {
      setError('Falha no login. Tente novamente.');
    }
  };

  return (
    <div className="min-h-screen bg-body grid place-items-center p-4">
      <div className="w-full max-w-sm bg-white dark:bg-[#181818] rounded-xl border border-zinc-200 dark:border-zinc-800 p-6 shadow-lg">
        <h1 className="text-xl font-extrabold text-zinc-900 dark:text-white mb-1">Entrar</h1>
        <p className="text-sm text-zinc-600 dark:text-zinc-400 mb-4">Acesso privado. Use suas credenciais.</p>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-sm text-zinc-700 dark:text-zinc-300 mb-1">Login</label>
            <input
              type="text"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Digite seu login (ex.: iago)"
              className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800 text-zinc-900 dark:text-zinc-100"
            />
          </div>
          <div>
            <label className="block text-sm text-zinc-700 dark:text-zinc-300 mb-1">Senha</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-2 rounded-md border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800 text-zinc-900 dark:text-zinc-100"
            />
          </div>
          {error && <p className="text-sm text-red-500">{error}</p>}
          <button type="submit" className="w-full px-3 py-2 rounded-md bg-[#1DB954] text-black font-semibold">Entrar</button>
        </form>
        <div className="mt-4 text-xs text-zinc-500 dark:text-zinc-400">
          <p>Dica (dev): e-mails contendo "admin" recebem papel de administrador.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
